module.exports = __webpack_public_path__ + "img/flow_chat-now.5b3ff919.svg";